import { types, actions } from './requests'
export const DELETEPRODUCTION_TYPES = {
    ...types('DELETEPRODUCTION'),
}
export const DELETEPRODUCTION_ACTIONS = {
    ...actions('DELETEPRODUCTION'),
}